var APP_URL = "https://inkxe.com/dev/shopifybetaxe/";
var PREVIEW_URL = APP_URL + "designer-tool/designer-assets/inkxe_com/previewimg/";
$(document).ready(function() {
  $(".ref-preview-img").each(function() {     
    var obj = $(this);
     var ref_id = obj.attr('data-ref-id');
      $.get(APP_URL + "designer-tool/designer-api/app-service/api_v4.php?reqmethod=getCustomPreviewImages&refids="+ref_id,function(data){
      	if(ref_id!=undefined){
            $.each(data,function(key, val){  
              if(key==ref_id && val.length>0){                                   
                 $.each(val,function(imgKey, imgObj){                                      
                  var newElement = '<li  class="product-image product-thumb customize-image" title="">'+'<img src="'+imgObj['customImageUrl']+'" width="75" height="75" alt="" rel="'+ref_id+'" style="display:block;" class="previewimg">'+'</li>';
                  //arr.push(newElement);
                  $(obj).append(newElement);
                });
              }
            });
	    } 
  });
});
});

/*
Utility function to allow for simple query string lookups
*/
function queryString()
{
   // This function is anonymous, is executed immediately and 
	// the return value is assigned to QueryString!
	var query_string = {};
	var query = window.location.search.substring(1);
	var varss = query.split("&");
    var vars = varss[1].split("--");
    
  
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
	      // If first entry with this name
	  if (typeof query_string[pair[0]] === "undefined") {
	    query_string[pair[0]] = decodeURIComponent(pair[1]);
	      // If second entry with this name
	  } else if (typeof query_string[pair[0]] === "string") {
	    var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
	    query_string[pair[0]] = arr;
	      // If third or later entry with this name
	  } else {
	    query_string[pair[0]].push(decodeURIComponent(pair[1]));
	  }
	} 
  
  return query_string;
}



function addItem()
{
    var query_string = {};
	var query = window.location.search.substring(1);
	var vars = query.split("&");
   // var vars = varss[1].split("--");

   
   for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
         // If first entry with this name
	  if (typeof query_string[pair[0]] === "undefined") {
	    query_string[pair[0]] = decodeURIComponent(pair[1]);
	      // If second entry with this name
	  } else if (typeof query_string[pair[0]] === "string") {
	    var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
	    query_string[pair[0]] = arr;
	      // If third or later entry with this name
	  } else {
	    query_string[pair[0]].push(decodeURIComponent(pair[1]));
	  }
   }
	
	
      /* Ref URL Parts
	        0: riaxe design ref ID
	        1: shopify variant id
	        2: quantity ordered			
	    */
    
	      //get potential of multiple items
	      var items = query_string.ref.split('--');
  		var itemNum = (items.length)-1;
  		console.log(itemNum);
      
	     // alert(Querys.ref.split('--'));
         // return false ;
     
      
          //loop through items
             
            
           for(var i in items)
            {    
               var this_item =items[i].split('-');
               //console.log(this_item[1],this_item[2],this_item[0]);
              
                //add the item
                   CartJS.addItem(this_item[1],this_item[2], { '_refid': this_item[0] }, {

                // Define a success callback to display a success message.
                "success": function(data, textStatus, jqXHR) {
                    $('#info').addClass('message-success');
                    $('#info').html('Loading.....Please Wait.');
                 
                  if(i == itemNum){
                    setTimeout(function() { window.location.href = '/cart';}, 3000);
                                         
                  }
                  
                },

                // Define an error callback to display an error message.
                "error": function(jqXHR, textStatus, errorThrown) {
                    $('#info').addClass('message-error');
                    $('#info').html('There was a problem adding to the cart!');
                }
            });  
         }
}

function ref_add_to_cart()
{
  alert(typeof qsLookup.ref);
  
    if(typeof qsLookup.ref != "undefined")
	{
	    /* Ref URL Parts
	        0: riaxe design ref ID
	        1: shopify variant id
	        2: quantity ordered			
	    */
    
	      //get potential of multiple items
	      var this_item,items = qsLookup.ref.split('--');
      
	      //loop through items
	      for(var i in items)
	      {        
	        //unpack item
	        this_item = items[i].split('-');
			
			//TODO: validate item
        
	        //add the item
	        $.ajax({
	          type: "POST",
	          url: '/cart/add.js',
	          data: {
	            quantity: this_item[2],
	            id: this_item[1],
				async: false,
	            properties: {
	              '_refid': this_item[0]
	            }
	          },
	          dataType: "json",
	          success: function(resp)
	          {
	            $("#info").html("Item Added!");
	          }
	        });
	      }      
		  
		 window.location.href = '/cart';
    }
    else
    {
      //TODO: error handling 
      $("#info").html("Error!");
    }
}


